import React from 'react';
import { Outlet } from 'react-router-dom';

export const MyMoneyV2 = () => <Outlet />;
